import { Stack } from "@chakra-ui/react";
import PageHeader from "components/layout/PageHeader";
import { Header } from "../components/header";
import { PaymentsTable } from "../components/tables/payments-table";

export function Payments() {
  return (
    <>
      <PageHeader title="Payments" />

      <Stack gap={4}>
        <Header />
        <PaymentsTable />
      </Stack>
    </>
  );
}
